import React from "react";
import KeyRow from "./KeyRow";

export default function KeysList({ keys, onRevoke }) {
  return (
    <div className="mcp-keys-list">
      {/* Desktop table */}
      <div className="mcp-table-wrapper mcp-desktop-only">
        <table className="mcp-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Key</th>
              <th>Wallet</th>
              <th>Created</th>
              <th>Last used</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {keys.map((k) => (
              <KeyRow key={k.prefix || k.id} keyItem={k} onRevoke={onRevoke} />
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="mcp-mobile-only">
        {keys.map((k) => (
          <KeyRow key={k.prefix || k.id} keyItem={k} onRevoke={onRevoke} variant="card" />
        ))}
      </div>
    </div>
  );
}
